import { render, staticRenderFns } from "./spar-attr-select.vue?vue&type=template&id=7a4053b8&scoped=true&"
import script from "./spar-attr-select.vue?vue&type=script&lang=js&"
export * from "./spar-attr-select.vue?vue&type=script&lang=js&"
import style0 from "./spar-attr-select.vue?vue&type=style&index=0&id=7a4053b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4053b8",
  null
  
)

export default component.exports